import ar from "./langs/ar.json";
import en from "./langs/en.json";
import es from "./langs/es.json";
import fr from "./langs/fr.json";
import ru from "./langs/ru.json";
import bn from "./langs/bn.json";
import de from "./langs/de.json";
import hi from "./langs/hi.json";
import fa from "./langs/fa.json";
import cn from "./langs/cn.json";
export const resources = {
    ar: { translation: ar, direction: "rtl" },
    en: { translation: en, direction: "ltr" },
    es: { translation: es, direction: "ltr" },
    fr: { translation: fr, direction: "ltr" },
    ru: { translation: ru, direction: "ltr" },
    bn: { translation: bn, direction: "ltr" },
    de: { translation: de, direction: "ltr" },
    hi: { translation: hi, direction: "ltr" },
    fa: { translation: fa, direction: "rtl" },
    cn: { translation: cn, direction: "ltr" },
};
